import React from 'react'
import { WindowManager } from '@shared/ui-react/FloatingWindow';
import { layerStore } from '@openlayers/tools/volume/tool-volumes-store';
import { MapToolsStore } from '@openlayers/MapToolsStore';
import { VolumeCalculationConfig } from './tool-volumes-dialog';

const getTitle = ( toolsStore: MapToolsStore ) => {
    return `BETA: ${
        toolsStore.volumeToolType === 'stockpile'
            ? __('js_map_measuring_tools.dem_volume_tool')
            : __('js_map_measuring_tools.model_volume_tool')
    }`;
};

export function openVolumeWindow(toolsStore: MapToolsStore) {
    WindowManager.open({
        group: 'map-tools',
        id: 'volume-tool',
        title: getTitle(toolsStore),
        showCloseButton: true,
        resize: 'both',
        defaultSizing: {
            width: window.innerWidth * 0.25,
            height: 250 + window.innerHeight * 0.6,
            x: window.innerWidth - window.innerWidth * 0.25 - 20,
            y: window.innerHeight - window.innerHeight * 0.9,
        },
        body: <VolumeCalculationConfig toolsStore={toolsStore} />,
        onClose: () => closeVolumeWindow(toolsStore),
    });
};

export function closeVolumeWindow( toolsStore: MapToolsStore ) {
    toolsStore.volumeTool.clearAll()
    layerStore.setReference(null);
    layerStore.setTarget(null);
    WindowManager.close('volume-tool');
};
